import { Building2, Users, Landmark, Banknote, Home, Briefcase } from 'lucide-react';

const serveItems = [
  {
    title: 'Employers & HR Teams',
    description: 'Streamline your hiring process with reliable background checks.',
    icon: Briefcase,
    bg: 'bg-[#2C2C2C]',
    span: '',
  },
  {
    title: 'Recruitment Agencies',
    description: 'Deliver verified candidates to your clients with confidence.',
    icon: Users,
    bg: 'bg-[#3A3A3A]',
    span: 'md:row-span-2',
    tall: true,
  },
  {
    title: 'Government & NGOs',
    description: 'Ensure compliance and transparency in public appointments.',
    icon: Landmark,
    bg: 'bg-[#1A1A1A]',
    span: '',
  },
  {
    title: 'Financial Institutions',
    description: 'Mitigate risk with thorough employee and partner vetting.',
    icon: Banknote,
    bg: 'bg-[#2C2C2C]',
    span: '',
  },
  {
    title: 'Landlords & Property Managers',
    description: 'Screen tenants effectively and protect your investments.',
    icon: Home,
    bg: 'bg-[#3A3A3A]',
    span: '',
  },
  {
    title: 'Legal & Compliance Firms',
    description: 'Support due diligence with verified background data.',
    icon: Building2,
    bg: 'bg-[#1A1A1A]',
    span: '',
  },
];

export default function WhoWeServeSection() {
  return (
    <section className="w-full bg-white px-4 md:px-6 lg:px-10 py-16 md:py-20 lg:py-24">
      <div className="max-w-[1400px] w-full mx-auto">
        {/* Section Title */}
        <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 text-center mb-16 md:mb-20">
          Who We Serve
        </h2>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5 lg:gap-6 auto-rows-[200px] md:auto-rows-[220px] lg:auto-rows-[240px]">
          {serveItems.map((item, index) => {
            const Icon = item.icon;
            return (
              <div
                key={index}
                className={`${item.bg} ${item.span} rounded-2xl lg:rounded-3xl p-6 md:p-8 flex flex-col justify-between relative overflow-hidden group hover:scale-[1.02] transition-transform cursor-pointer`}
              >
                {/* Subtle pattern overlay */}
                <div className="absolute inset-0 opacity-[0.04] bg-[radial-gradient(circle_at_30%_20%,white_1px,transparent_1px)] bg-[size:20px_20px]" />

                {/* Icon */}
                <div className="relative z-10">
                  <div className="w-10 h-10 md:w-12 md:h-12 bg-[#FF6B35] rounded-xl flex items-center justify-center">
                    <Icon className="w-5 h-5 md:w-6 md:h-6 text-white" />
                  </div>
                </div>

                {/* Text */}
                <div className="relative z-10 mt-auto">
                  <h3 className="text-white text-lg md:text-xl lg:text-2xl font-bold mb-1 md:mb-2">
                    {item.title}
                  </h3>
                  <p className="text-gray-400 text-xs md:text-sm leading-relaxed">
                    {item.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
